import { APIClient } from "../helpers/api_helper";

const api = new APIClient();
const RESOURCE = "/public/cs/unsubscribe";

export interface PublicCsUnsubscribeData {
  user_name: string;
  tenant_name: string | null;
  already_opted_out: boolean;
  message: string;
}

export const getPublicCsNurtureUnsubscribe = async (
  token: string
): Promise<{ success: boolean; data: PublicCsUnsubscribeData; message?: string }> =>
  api.get(RESOURCE, { t: token });

export const confirmPublicCsNurtureUnsubscribe = async (
  token: string
): Promise<{ success: boolean; data: PublicCsUnsubscribeData; message?: string }> =>
  api.create(RESOURCE, { t: token });
